let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../../utils/FormUtils");
let Constants = require("../../../utils/Constants");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let AuthedUserSession = require("../../../utils/AuthedUserSession");
let DisplaylistSpeaker_to_actionlistSaveData = require("./DisplaylistSpeaker_to_actionlistSaveData");

let isPlaceholderValue = function(v){
    return (v === null) || (v === undefined);
};

let ActionItemForm = dd.createClass({
    mixins: [FormMixin],
    getInitialValues(props){
        let {item} = props;
        if(!item){
            return null;
        }
        let data = {
            description: item.description,
            activateonstatus: item.activateonstatus == -1 ? null : item.activateonstatus,
            duedelta: esUtils.toInt(item.duedelta),
            duebasedon: item.duebasedon,
            vieworder: item.vieworder,//even though they don't edit this we want it to be sent to the server
            assignedto: item.assignedto
        };

        data.duebasedon = data.duedelta < 0 ? "before" : "after";
        data.duebasedon += "_";
        data.duebasedon += /STRT/i.test(item.duebasedon) ? "STRT": "STAT";

        data.duedelta = Math.abs(data.duedelta);

        return data;
    },
    buildSchema(){
        let data = this.state.data || {};
        let {speaker} = this.props;

        let schema = {
            description: {
                label: "Item Description",
                type: "text",
                validate: FormUtils.v.required,
                help_text: "ex: 'send invoice', 'book travel', etc"
            },
            activateonstatus: {
                label: "When does this item apply?",
                type: "select",
                validate: FormUtils.v.optional,
                placeholder: "manually applied",
                options: {
                    0: "When the event is held",
                    1: "When the event is confirmed",
                    9: "When the event is canceled",
                    10: "When the event is lead"
                },
                help_text: "ex: for 'book travel', then choose 'when event is confirmed. For 'confirm hold status', choose 'when the event is held'."
            },
            duedelta: {
                label: "# of days",
                type: "number",
                validate: FormUtils.v.integer,//positive or negative
                min: 0
            },
            duebasedon: {
                label: "When is this item normally due?",
                type: "select",
                dont_sort_options: true,
                options: (function(){
                    let st = _.has(Constants.EVENT_STATUSES_by_num, data.activateonstatus)
                        ? Constants.EVENT_STATUSES_by_num[data.activateonstatus]
                        : "created";
                    return {
                        before_STRT: "days BEFORE the event starts",
                        after_STRT: "days AFTER the event starts",

                        after_STAT: "days AFTER the event is " + st
                    };
                }()),
                help_text: "ex: if you book travel 4 weeks prior to the event, then choose 'days BEFORE the event starts'. and enter 28 in the box."
            },
            assignedto: {
                label: "Who is usually responsible for this?",
                type: "select",
                placeholder: "not assigned",
                validate: FormUtils.v.optional,
                options: _.assign({
                    "[ME]": "* the person who enters the event",//see class.Event.php::TODO_ASSIGNEDTO_ME
                    "[SPEAKER]": "* the speaker"//class.Event.php::TODO_ASSIGNEDTO_SPEAKER
                }, _.object(_.map(speaker.coworkers, function(coworker){
                    return [coworker.id, coworker.name];
                })))
            }
        };
        if (AuthedUserSession.is_st_family) {
            schema.assignedto.options["[EVENTREP]"] = "* event representative";//class.Event.php::TODO_ASSIGNEDTO_REP
        }
        if(isPlaceholderValue(data.activateonstatus)){
            delete schema.duedelta;
            delete schema.duebasedon;
        }
        return schema;
    },
    render(){
        let fields = this.Form_buildSchema();
        let errors = this.state.errors || {};
        let buildInput = this.Form_buildInput;

        let {onClose} = this.props;

        let renderInput = function(name, no_wrap){
            let body = dd.div({className: errors[name] ? "has-error" : null},
                buildInput(fields[name], name),
                errors[name] ? dd.span({className: "help-block"}, errors[name]) : null
            );
            return no_wrap ? body : dd.div({className: "row"},
                dd.div({className: "col-sm-1"}),
                dd.div({className: "col-sm-11"},
                    body
                )
            );
        };
        let renderLabel = function(name){
            let field = fields[name];
            return dd.label(null, field.label);
        };
        let renderHelpText = function(name){
            let field = fields[name];
            return dd.div({className: "row"},
                dd.div({className: "col-sm-1"}),
                dd.div({className: "col-sm-11"},
                    dd.span({className: "help-block"}, field.help_text)
                )
            );
        };

        return dd.form({onSubmit: this.Form_onSubmit},
            renderLabel("description"),
            renderInput("description"),
            renderHelpText("description"),

            renderLabel("activateonstatus"),
            renderInput("activateonstatus"),
            renderHelpText("activateonstatus"),

            _.has(fields, "duebasedon") ? dd.div(null,
                renderLabel("duebasedon"),
                dd.div({className: "row"},
                    dd.div({className: "col-sm-1"}),
                    dd.div({className: "col-sm-4"},
                        renderInput("duedelta", true)
                    ),
                    dd.div({className: "col-sm-7"},
                        renderInput("duebasedon", true)
                    )
                ),
                renderHelpText("duebasedon")
            ) : null,

            renderLabel("assignedto"),
            renderInput("assignedto"),

            dd.div({style: {margin: "20px 0", textAlign: "right"}},
                dd.button({className: "btn btn-primary", type: "submit"}, "Save"),
                " ",
                dd.button({className: "btn btn-default", onClick: onClose}, "Close")
            )
        );
    }
});

module.exports = dd.createClass({
    mixins: [RadioServiceMixin],
    RadioService_setup(){
        return {
            Actionlists_save: {
                key(){
                    return 1;
                },
                on: {
                    succeeded(){
                        this.props.onClose();
                    }
                }
            }
        };
    },
    __onSubmit(data){
        let item = _.cloneDeep(data);
        item.duedelta = esUtils.toInt(item.duedelta);
        item.assignedto = isPlaceholderValue(item.assignedto)
            ? null
            : item.assignedto;
        item.activateonstatus = isPlaceholderValue(item.activateonstatus)
            ? -1
            : esUtils.toInt(item.activateonstatus);

        if(/before/.test(item.duebasedon)){
            item.duedelta = -item.duedelta;
        }
        if(/_STRT/.test(item.duebasedon)){
            item.duebasedon = "STRT";//start date
        }else{
            item.duebasedon = "STAT";//status change
        }

        let list_id = this.props.list_id;
        let item_id = this.props.item.id;
        let speaker = this.props.speaker;
        let to_save = {};
        to_save[speaker.sid] = DisplaylistSpeaker_to_actionlistSaveData(speaker);
        //update the changed item
        to_save[speaker.sid][list_id].items[item_id] = item;
        radio("Actionlists_save").broadcast(to_save);
    },
    render(){
        let ajax = this.state.Actionlists_save;
        let {onClose, item, speaker} = this.props;

        return Modal({
                title: "Action Item",
                buttons: [],
                onClose: ajax.waiting ? null : onClose
            },
            ErrorAlert({message: ajax.error}),
            LoadingWrap({is_loading: ajax.waiting, text: "Saving..."},
                dd.p(null,
                    "Make changes to the master to-do list, which affects all events for the speaker. Changes made here will not affect todo-items already created."
                ),
                ActionItemForm({
                    speaker,
                    item,
                    onClose,
                    onSubmit: this.__onSubmit
                })
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/action_lists/ActionListItemEditor.js